<template>
  <Loader v-if="isDataLoading"/>
  <div v-else>
    <Table
      :title="$t('views.backup.title')"
      :tooltip="$t('views.backup.tooltip')"
      :headers="backupsHeaders"
      :rows="backupsRows"
      :values="backups"
      @export="exportBackup"
      />
  </div>
</template>

<script>
import AVAMAR from '@/api/avamar';

import Loader from '@/components/Loader.vue';

export default {
  name: 'backup',
  components: {
    Table: () => import('@/components/Table'),
    Loader,
  },
  data() {
    return {
      isDataLoading: true,
      backupsHeaders: [
        {
          label: this.$t('views.backup.config.backupsHeaders.name'),
          field: 'name',
        },
        {
          label: this.$t('views.backup.config.backupsHeaders.date'),
          field: 'date',
        },
        {
          label: this.$t('views.backup.config.backupsHeaders.policy'),
          field: 'policy_group',
        },
        {
          label: this.$t('views.backup.config.backupsHeaders.status'),
          field: 'status_code',

        },
        {
          label: this.$t('views.backup.config.backupsHeaders.bytes'),
          field: 'bytes_scanned',
        },
      ],
      backupsRows: [
        {
          value: row => row.name,
        },
        {
          value: row => row.date,
        },
        {
          value: row => row.policy_group,
        },
        {
          icon: (row) => {
            if (row.status_code === 30000) {
              return 'valid-round-inverse';
            }
            return 'warning-inverse';
          },
          color: (row) => {
            if (row.status_code === 30000) {
              return 'success';
            } if (row.status_code === 30005) {
              return 'warning';
            }
            return 'danger';
          },
        },
        {
          value: row => row.bytes_scanned,
        },
      ],
      backups: [],
    }
  },
  computed: {
  },
  created() {
    this.listBackups();
  },
  methods: {

    listBackups() {
      AVAMAR.activity().then(
        (res) => {
          this.isDataLoading = false;
          if (res.data && res.data.length) {
            this.backups = res.data;
          }
        },
      );
    },

    exportBackup() {
      AVAMAR.export();
    },
  },
};
</script>
